import { faPencil, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { CompanyHoliday } from "src/app/interfaces/Index";
import { CompanyHolidayService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { Calendar } from "primereact/calendar";

type Props = {};
type State = {
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	masterItems: CompanyHoliday[];
	items: CompanyHoliday[];
	selectedItem: CompanyHoliday;
	showDeleteModal: boolean;
	showItemInfoModal: boolean;
	submitted: boolean;
};

export class AdminCompanyHolidays extends React.Component<Props, State> {
	dt: any;	
	toast: any;
	itemName: string = "Company Holiday";
	itemNamePlural: string = "Company Holidays";

	constructor(props: Props) {
		super(props);
		this.state = {isLoading: false, filters1: {"global": { value: null, matchMode: FilterMatchMode.CONTAINS }}, globalFilter: "", masterItems: [], selectedItem: new CompanyHoliday(), items: [], showDeleteModal: false, showItemInfoModal: false, submitted: false};
	}

	componentDidMount() {
		this.getItems();
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteItemConfirm()}></Button>
			</>
		);
	}

	async deleteItemConfirm() {
		this.setState({isLoading: true});
			const res = await CompanyHolidayService.deleteSingleById(this.state.selectedItem.id);

			if (res.ok) {
				this.setState({isLoading: false, showDeleteModal: false});
				this.toast.show({closable: false, detail: this.itemName + " has been deleted", life: 5000, severity: "success", summary: this.itemName + " deleted!"});
				this.getItems();
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
	}

	itemInfoFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new CompanyHoliday(), showItemInfoModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
		);
	}

	globalFilterChange(e: any) {
		let value = "";
		if (e !== ""){
			value = e.target.value;
			let newData = this.state.masterItems.filter(function(item){
				return item.name?.toLowerCase().includes(value.toLowerCase());
			 });
			 this.setState({items:newData});
		} else this.setState({items:this.state.masterItems});
		this.setState({globalFilter:value});    
	}

	async getItems() {
		this.setState({isLoading: true});
		const res = await CompanyHolidayService.getAll();

		if (res.ok) {
			const response = await res.json();
			this.setState({isLoading: false, items: response, masterItems:response});
		} else {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new CompanyHoliday({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new CompanyHoliday({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{paddingTop: "1.5rem"}}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							<DataTable loading={this.state.isLoading} ref={(el) => this.dt = el} scrollable scrollHeight="flex" style={{height: "calc(100vh - 17.5rem)"}} value={this.state.items} sortField="name" sortOrder={1}>
								<Column field="name" header="Name" sortable></Column>
								<Column dataType="date" body={(rowData: any) => this.renderDate(rowData.endDate)} field="startDate" header="Start Date" sortable></Column>
								<Column dataType="date" body={(rowData: any) => this.renderDate(rowData.endDate)} field="endDate" header="End Date" sortable></Column>
								<Column style={{width: 75}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedItem: rowData, showItemInfoModal: true})} style={{backgroundColor: colours.buttons.edit, borderColor: colours.buttons.edit, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({selectedItem: rowData, showDeleteModal: true})} style={{backgroundColor: colours.buttons.delete, borderColor: colours.buttons.delete, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
										</Button>
									</div>
								)}></Column>
							</DataTable>
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
								<Row>
									<Col>
										<div className="field">
											<label htmlFor="name">Holiday Name <span className="required">*</span></label>
											<InputText id="name" value={this.state.selectedItem.name} onChange={(e) => this.inputChange(e, "name")}/>
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="startDate">Start Date <span className="required">*</span></label>
											<Calendar dateFormat="dd/mm/yy" id="startDate" onChange={(e) => this.inputChange(e, "startDate")} required value={new Date(this.state.selectedItem.startDate)} showButtonBar />
										</div>
									</Col>
									<Col>
										<div className="field">
											<label htmlFor="endDate">End Date <span className="required">*</span></label>
											<Calendar dateFormat="dd/mm/yy" id="endDate" onChange={(e) => this.inputChange(e, "endDate")} required value={new Date(this.state.selectedItem.endDate)} showButtonBar />
										</div>
									</Col>
								</Row>
							</Dialog>
							<Dialog className="p-fluid" footer={() => this.deleteItemFooter()} header={"Delete " + this.itemName} modal onHide={() => this.setState({ showDeleteModal: false })} style={{ width: "75%" }} visible={this.state.showDeleteModal}>
								<Row>
									<Col>
										Are you sure you wish to delete the selected item?
									</Col>
								</Row>
							</Dialog>
						</div>
					</Col>
				</Row>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}

	renderDate(e: Date) {
		const date = new Date(e);
		return date.toLocaleDateString('en-GB', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		});
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{backgroundColor: colours.buttons.add, borderColor: colours.buttons.add, marginRight: 10}} onClick={() => this.setState({selectedItem: new CompanyHoliday(), showItemInfoModal: true})}></Button>
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
			<div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={()=>{this.globalFilterChange("")}} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilter} onChange={(e)=> {this.globalFilterChange(e)}} placeholder="Keyword Search" />
                </span>
            </div>
				<Button icon="pi pi-download" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt.exportCSV()}></Button>
			</>
		);
	}

	async saveItem() {
		this.setState({isLoading: true});
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await CompanyHolidayService.createSingle(this.state.selectedItem);

			if (res.ok) {
				this.setState({isLoading: false, showItemInfoModal:false});
				this.toast.show({closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!"});
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
		} else { // Save existing
			const res = await CompanyHolidayService.updateSingleById(this.state.selectedItem.id, this.state.selectedItem);

			if (res.ok) {
				this.setState({isLoading: false, showItemInfoModal:false});
				this.toast.show({closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
			} else {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
		}

		await this.getItems();
	}		
}